define('v3/Common/Bindings/Tooltip.Binding',['jquery', 'knockout', 'jquery.tooltip'], function ($, ko) {
	ko.bindingHandlers.tooltip = {
		init: function (element, valueAccessor, allBindingsAccessor) {
			var hasTooltip = ko.unwrap(valueAccessor());

			if (hasTooltip) {
				var options = ko.unwrap(allBindingsAccessor().tooltipOptions);
				var tooltip;
				if (options) {
					tooltip = $(element).tooltip(ko.unwrap(valueAccessor()), options);
				} else {
					tooltip = $(element).tooltip(ko.unwrap(valueAccessor()));
				}

				ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
					tooltip.destroy();
				});
			}
		},
		update: function (element, valueAccessor) {
			var hasTooltip = ko.unwrap(valueAccessor());

			if (hasTooltip) {
				$(element).tooltip(ko.unwrap(valueAccessor()));
			}
		}
	};
});
